import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Map} from 'immutable';

import {PageHead} from 'components/header/components';
import Box from 'components/box';
import Spinner from 'spinner';
import {UserDetailList} from './user-detail-list';
import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';
import {loadStaffDetail} from 'redux/actions/admin/users';

const mapStateToProps = state => ({
  user: state.users.get('userDetail'),
  isFetching: state.users.get('usersAreLoading')
});

const mapDispatchToProps = dispatch => ({
  onLoad: (id) => dispatch(loadStaffDetail(id))
});

class UserDetail extends Component {

  componentWillMount() {
    this.props.onLoad(this.props.match.params.id);
  }

  render() {

    if (this.props.isFetching) {
      return <Spinner />
    }

    if (this.props.user === undefined) {
      return <Spinner/>;
    }

    return(
      <div>
          <Breadcrumbs>
              <li><Link to="/admin/">Головна</Link></li>
              <li><Link to="/admin/operators">Оператори</Link></li>
              <li><Link to={`/admin/operators/detail/${this.props.user.get('id')}`}>{this.props.user.get('user_data').get('last_name')} {this.props.user.get('user_data').get('first_name')}</Link></li>
          </Breadcrumbs>
        <PageHead>
          <h2>Інформація про користувача</h2>
        </PageHead>
        <Box>
          <UserDetailList user={this.props.user} />
        </Box>
      </div>
    )
  }
}

UserDetail.propTypes = {
  user: PropTypes.instanceOf(Map).isRequired,
  isFetching: PropTypes.bool.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);



// WEBPACK FOOTER //
// ./src/admin/users/detail.js